import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { IMultipleIdsParams } from '../../../spacesPlatform/utils/actionParams';

export interface SetEnabledStatusForSchedulesParams extends IMultipleIdsParams {
  enabled: boolean;
}

export class SetEnabledStatusForSchedulesRequest extends Request<SetEnabledStatusForSchedulesParams, IResult> {
  constructor(ids: string[], enabled: boolean) {
    super('setEnabledStatusForSchedules', { ids: ids, enabled: enabled });
  }
}
